const MAX_URL_LENGTH = 2048;
const MAX_ALT_LENGTH = 250;

/** Devuelve el texto utilizable, o null si el valor no sirve como URL. */
const normalizeUrl = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > MAX_URL_LENGTH) return null;
  return trimmed;
};

/**
 * Resuelve la URL del logo del adquirente.
 * Precedencia: configuracion local del integrador, configuracion de captura
 * entregada por /flex-session, y por ultimo el asset del CDN.
 * El logo pertenece al adquirente, que es uno solo por comercio, por eso no
 * existe variante por metodo de pago.
 */
export const resolveAcquirerLogo = ({ localSettings, captureConfigurations, defaultUrl }) => {
  const candidates = [
    localSettings?.acquirer_logo,
    captureConfigurations?.acquirer_logo
  ];
  for (const candidate of candidates) {
    const url = normalizeUrl(candidate);
    if (url !== null) return url;
  }
  return defaultUrl;
};

/**
 * Resuelve el override del texto alternativo del logo del adquirente.
 * Devuelve null cuando ninguna fuente lo define, para que el componente
 * aplique la clave de traduccion.
 */
export const resolveAcquirerLogoAlt = ({ localSettings, captureConfigurations }) => {
  const candidates = [
    localSettings?.acquirer_logo_alt,
    captureConfigurations?.acquirer_logo_alt
  ];
  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const trimmed = candidate.trim();
    if (trimmed.length > 0) return trimmed.slice(0, MAX_ALT_LENGTH);
  }
  return null;
};
